<template>
  <div v-loading="loading" class="pl-20">

    <el-timeline :reverse="false">
      <el-timeline-item
        v-for="(note, index) in notes"
        :key="index"
        :timestamp="moment(note.createdAt)">
        
            <!-- <img src="@/assets/images/unknown-user3.jpg" class="icon-time" slot="others" alt="Grace Hopper"> -->
          <p class="fs-14" v-html="note.description"></p>
          <p v-if="note.filename != null">
            <a href="#" @click.prevent="downloadFile(note)">
              <i class="mdi mdi-file-document" style="font-size:14px;margin-right:5px;"></i>
              <small>{{note.filename}}</small>
            </a>
          </p>
          <small>- {{note.created_by.first_name}} {{note.created_by.last_name}}</small>
          <div style="display:block;margin-top:20px;">
            <el-button

            @click="deleteNote(note.id, index)"
            style="position:relative;float:right; padding: 2px 0;margin-left:10px;top:-55px;margin-right:10px;"
            type="text"
          >
            <i class="el-icon-delete"/>
          </el-button>
          <el-button
            @click="editNote(note.id, index)"
            style="position:relative;float:right; padding: 2px 0;margin-left:10px;top:-55px;"
            type="text"
          >
            <i class="el-icon-edit"/>
          </el-button>
        </div>
      </el-timeline-item>
    </el-timeline>
    <div v-if="notes.length==0">
      <span class="fs-14">{{ $t('clients.noNotes') }}</span>
    </div>
    <div v-if="page < pages" style="widht:100%;text-align:center;">
      <el-button type="primary" plain @click="loadMore()">{{ $t('clients.moreNotes') }}</el-button>
    </div>
  </div>
</template>
<script>
import axios from "axios"
import { Timeline, TimelineItem, TimelineTitle } from 'vue-cute-timeline'
import moment from 'moment-timezone'
import { EventBus } from '@/core/event-bus'

export default {
	name: 'NoteHistory',
	props: {
    customerId : String,
    contactId : String,
  },
	components : {
    Timeline,
    TimelineItem,
    TimelineTitle
	},
	data() {
		return {
      notes : [],
      loading : true,
      page : 1,
      pages : 1,
      limit:5
		}
	},
	computed : {},
	methods : {
    editNote (noteId, index) {
      this.$emit('edit', {note: this.notes[index], index});
    },
    deleteNote (noteId, index){
      let id = this.contactId||this.customerId;
      let path = this.contactId?"/contacts/":"/customers/";

      this.$confirm('Ceci supprimera définitivement la note. Continuer?', 'Attention', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API"+path+id+ "/notes/" + noteId)
            .then(() => {
              this.notes.splice(index, 1);
              this.$message.success('Suppression de la note effectuée avec succès!')
            }).catch((err) => {
              this.$message.error('Oups... une erreur est survenue! Veuillez réessayer plus tard.')
            })
        }).catch(err=>{
          /* ne rien faire */
        })


    },
    getCustomerNotes(){
      let id = this.contactId||this.customerId;
      let path = this.contactId?"/contacts/":"/customers/";

      return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API"+path+id+"/notes?page=1&limit="+this.limit)
  				.then(response=>{
  					return response.data;
  				});
    },
    moment(datetime){
			return  moment(datetime).format('LLL');
		},
    handleAddingNote(){
      this.loading=true;
    },
    handleEditedNote(note){
      const index = _.findIndex(this.notes, n => n.id === note.id);
      this.notes[index] = note;
      this.loading=false;
    },
    handleAddedNote(note){

      var user = JSON.parse(localStorage.user);
      note.created_by = {}
			note.created_by.first_name = user.first_name ;
      note.created_by.last_name = user.last_name;

      this.notes.unshift(note);

      this.loading=false;
    },
    loadMore(){
      this.page++;
      this.loading=true;
      this.getCustomerNotes()
        .then(response=>{
          _.forEach(response.notes, note=>{
            this.notes.push(note);
          })
          this.loading=false;
        })
    },
    downloadFile(note){
      this.loading=true;
      axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/notes/"+note.id+"/file",{responseType: 'arraybuffer'})
  				.then(response=>{
            // console.log("response : ", response);
            // console.log("headers : ", response.headers);
            var headers = response.headers;
            var blob = new Blob([response.data],{type:headers['content-type']});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = note.filename;
            link.click();
            this.loading=false;
  				});
    }
  },
  created(){
    this.getCustomerNotes()
      .then(notes=>{
        this.notes = notes.notes;
        this.pages = notes.pages;
        this.loading=false;
      })
  },
  mounted(){
    EventBus.$on('adding-note', this.handleAddingNote);
    EventBus.$on('note-added', this.handleAddedNote);
    EventBus.$on('note-edited', this.handleEditedNote);
  }
}
</script>
<style lang="scss">
@import '../assets/scss/_variables';

.el-loading-mask{
  left:-20px;
}

.el-loading-spinner{
    top:20px;
}

.timeline-box {
  padding: 50px;
}
.timeline {
  max-width: 1200px;
  margin: 0px auto;
  font-family: inherit;
}
.timeline, .timeline-title {
  color: $text-color;
  line-height: 1.4;
  cursor: default;
}
.append {
    font-size: .8em;
    margin-top: 3px;
    color: transparentize($text-color, .5);
}
.icon-time {
  width: 32px;
  margin-top: 2px;
  border-radius: 50%;
}
</style>
